module.exports = __webpack_public_path__ + "assets/img/s2_tab2.45f9f034.png";